import React from 'react';
import { Divider } from '../Divider/Divider';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
/**
 * @public
 */
export function ChatMessageSeparator({
  message
}) {
  return React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: 'center'
  }, React.createElement(Divider, {
    width: '100%'
  }), message && React.createElement(Text, {
    color: 'text.light',
    textAlign: 'center',
    textStyle: 'subheading6',
    textWrap: 'nowrap',
    mx: 3
  }, message), React.createElement(Divider, {
    width: '100%'
  }));
}